import { TMarketplace } from '@com/core/common/types/config';
import { baseConfig, IMG_BASE } from '@com/core/common/baseConfig';
import { TRegionAPI, TRegionSEO, TLocaleAPI, TLanguage } from '@com/core/common/types/locale';
import { TI18nOptions } from '@com/core/common/types/webconfig';
import { TMarketplaceConfig } from '../common/types/config';

export const IS_DOCKER_NON_DEV = process.env.DOCKER === 'yes' && process.env.ENV !== 'dev';
// eslint-disable-next-line no-underscore-dangle
export const MARKETPLACE = process.env._MARKETPLACE as TMarketplace;
export const CONTENT_HEADER = process.env.CONTENT_HEADER || 'desktop';
// eslint-disable-next-line no-underscore-dangle
export const DOMAIN = process.env.ENV !== 'prod' ? `${MARKETPLACE}stg` : MARKETPLACE;

export const IS_BROWSER = typeof window !== 'undefined';
export const SVC_ENDPOINT = IS_BROWSER ? '/_svc' : `https://api-external.${DOMAIN}.com/_svc`;

const marketplaceConfig: TMarketplaceConfig = {
    ...baseConfig,
    regions: {
        ...baseConfig.regions,
        ae: {
            ...baseConfig.regions.ae,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@kul.com',
            supportPhone: '80058522',
            help: {
                en: 'https://kul.zendesk.com/hc/en-us',
                ar: 'https://kul.zendesk.com/hc/ar',
            },
        },
        sa: {
            ...baseConfig.regions.sa,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@kul.com',
            supportPhone: '8001160123',
            help: {
                en: 'https://kul.zendesk.com/hc/en-us',
                ar: 'https://kul.zendesk.com/hc/ar',
            },
        },
        eg: {
            ...baseConfig.regions.eg,
            codLimit: 5000,
            enabled: false,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@kul.com',
            supportPhone: 'xxxxx',
            help: {
                en: 'https://kul.zendesk.com/hc/en-us',
                ar: 'https://kul.zendesk.com/hc/ar',
            },
        },
    },
    endpoints: {
        ...baseConfig.endpoints,
        catalog: IS_DOCKER_NON_DEV ? 'http://catalog-kul-noratelimit/api/u' : SVC_ENDPOINT.replace('/_svc', ''),
    },
    urls: {
        ...baseConfig.urls,
        imgBase: `${baseConfig.urls.imgBase}/kul/images/`,
        colorSwatches: 'https://a.nooncdn.com/cms/pages/20181025/0ce4c3a5d392155933d4571ef91fc179',
        appStore: 'xxx',
        googlePlay: 'xxx',
        facebook: 'https://www.facebook.com/helloKUL/',
        twitter: 'https://twitter.com/helloKUL/',
        instagram: 'https://www.instagram.com/kul/',
        linkedin: '',
        supportInfo: {
            careers: 'https://www.linkedin.com/company/nooncom/jobs/',
            partners: `https://login.noon.partners/en/register`,
        },
    },
    assets: {
        ...baseConfig.assets,
        icons: {
            ...baseConfig.assets.icons,
            shipmentMethod: {
                dd: '',
                sc: '',
                sdd: '',
                fallback: '',
            },
            favicon: `${IMG_BASE}/kul/icons/favicon.ico`,
            shipment: ``,
            address: ``,
            cart: `${IMG_BASE}/kul/icons/cart-white.svg`,
            cartBlue: `${IMG_BASE}/kul/icons/cart-blue.svg`,
            cartBlack: `${IMG_BASE}/kul/images/icons/cart-black.svg`,
            checkboxChecked: ``,
            checkboxUnchecked: ``,
            claims: ``,
            collectionPointsToggle: ``,
            credits: ``,
            edit: ``,
            globe: ``,
            hamburger: ``,
            home: ``,
            magnifyingGlass: ``,
            orders: `${IMG_BASE}/kul/images/icons/orders.svg`,
            payments: ``,
            preferences: '',
            profile: ``,
            returns: `${IMG_BASE}/noon/icons/account_returns.svg`,
            shop: ``,
            signOut: ``,
            wishListBlack: `${IMG_BASE}/kul/images/icons/wishlist-black.svg`,
            wishList: `${IMG_BASE}/kul/images/icons/wishlist.svg`,
            trash: `${IMG_BASE}/kul/icons/remove-grey.svg`,
            user: `${IMG_BASE}/kul/icons/user.svg`,
            nonReturnable: `${IMG_BASE}/kul/images/icons/non-returnable.svg`,
        },
        images: {
            ...baseConfig.assets.images,
            addressesEmptySlate: ``,
            addressCollectionIndicator: ``,
            addressLatLngIndicator: ``,
            cartEmpty: `${IMG_BASE}/kul/images/cart-empty.png`,
            claimsEmptySlate: ``,
            claimsSuccessSlate: ``,
            claimsTypeChecked: ``,
            claimsTypeUnchecked: ``,
            claimsTypeDamage: ``,
            claimsTypeProtection: ``,
            defaultMap: ``,
            defaultProductPlaceholder: ``,
            error404: '',
            fulfilmentExpressAr: `${IMG_BASE}/kul/images/express-ar.svg`,
            fulfilmentExpressEn: `${IMG_BASE}/kul/images/express-en.svg`,
            fulfilmentPreOrderAr: ``,
            fulfilmentPreOrderEn: ``,
            logoBG: '', // Big logo that's behind the login page
            mapCollectionPointPickup: ``,
            mapCollectionPointLocker: ``,
            mapCollectionPointToggle: ``,
            mapLocateMeEn: ``,
            mapLocateMeAr: ``,
            mapLandmarkPin: ``,
            returnsEmptyState: '', // returns page empty status image for BlankSlate
            returnablesEmptyState: '',
            returnSuccess: '', // returns page success status image for BlankSlate
            transferRequestSuccess: '', // transfer request page success status image for BlankSlate
            bankTransferEmpty: '', // transfer list page empty status image for BlankSlate
            chevronRight: '',
            chevronRightWhite: '',
            paymentEmptySlate: '',
            secure: `${IMG_BASE}/kul/images/secure.svg`,
        },
    },
    headerSupportBar: false,
    gtm: {
        ...baseConfig.gtm,
        gtmID: 'xxx',
        gaID: 'xxx',
        optimizeID: 'xxx',
    },
    enabledFeatures: {
        loyalty: false,
    },
};

export default marketplaceConfig;

// Computed Locale Configurations
export const SEO_REGIONS = Object.keys(baseConfig.regions).map(
    (region: string) => baseConfig.regions[region as TRegionAPI].seo,
);
const seoLocalesArr = SEO_REGIONS.map(
    (seoRegion: TRegionSEO) =>
        baseConfig.languages.map((language: TLanguage) => `${seoRegion}-${language}` as TLocaleAPI) as TLocaleAPI[],
);
export const SEO_LOCALES = [].concat(...(seoLocalesArr as [])) as TLocaleAPI[];
export const API_REGIONS = Object.keys(baseConfig.regions);

// Common i18n config (server, client)
export const i18nOptions: TI18nOptions = {
    lowerCaseLng: true,
    defaultLanguage: SEO_LOCALES[0],
    otherLanguages: [...SEO_LOCALES, ...baseConfig.extrai18nLocales],
    ignoreRoutes: ['/_next', '/static', '/_svc', '/hc'],
    whitelist: SEO_LOCALES,
};
